/**
 * @param {string|number} string
 * @returns {string}
 */
function removeSsnYearPrefix (string) {
  if (!string) return string

  const ssn = string.toString()
  if (ssn.substring(0, 2) === '19' || ssn.substring(0, 2) === '20') {
    return ssn.substring(2)
  }

  return ssn
}

module.exports = { removeSsnYearPrefix }
